export const news = {
    'news.title': '{title} - Новости | R.Toys',
    'news.default': 'Новости',
}
